import { render, staticRenderFns } from "./SearchProfessionType.vue?vue&type=template&id=3ce1ff3a&scoped=true&"
import script from "./SearchProfessionType.vue?vue&type=script&lang=js&"
export * from "./SearchProfessionType.vue?vue&type=script&lang=js&"
import style0 from "./SearchProfessionType.vue?vue&type=style&index=0&id=3ce1ff3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1ff3a",
  null
  
)

export default component.exports